<template>
  <div class="side-item"
    :class="{active:currentItem.id===data.id}"
    @click="clickHandle(data)">
    <div class="brand">{{data.name[0]}}</div>
    <span class="name">{{data.name}}</span>
    <span class="count">{{data.member_total}}</span>
  </div>
</template>
<script>
export default {
  name: 'SideItem',
  props: ['currentItem', 'data'],
  methods: {
    clickHandle (data) {
      if (this.currentItem.id === data.id) {
        return
      }
      this.$emit('currentChange', data)
    }
  }
}
</script>
<style lang="less">
.side-item {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #EBEEF5;
  position: relative;
  cursor: pointer;

  &.active::after {
    position: absolute;
    top: 0;
    left: 0;
    content: '';
    height: 100%;
    width: 3px;
    background-color: red;
  }

  .brand {
    width: 25px;
    height: 25px;
    line-height: 25px;
    color: #ffffff;
    font-size: 16px;
    text-align: center;
    border-radius: 5px;
    background-color: #008D4C;
    margin-left: 15px;
    margin-right: 10px;
  }

  .name {
    font-size: 14px;
    color: #444444;
  }

  .count {
    font-size: 15px;
    color: #777777;
    position: absolute;
    right: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SideItem/SideItem.vue